import React from 'react'
import Dashboard from './Dashboard'
import { Route, Routes } from 'react-router-dom'
import Service from '../pages/data/SubCategory'
import '../pages/css/index.css'
import Unit from '../pages/data/Unit'
import ServiceCategory from '../pages/data/Service'
import WorkingDay from '../pages/data/WorkingDay'
import Banner from '../pages/data/banner'
import MainService from '../pages/data/Category'
import UploadImage from '../pages/data/UploadImage'

const Content = () => {
    return (
        <>
            <Routes>
                <Route path='/' element={<Dashboard />} />
                {/* <Route path='/dashboard' element={<Dashboard />} /> */}
                <Route path='/banner' element={<Banner />} />
                <Route path='/unit' element={<Unit />} />
                <Route path='/mainService' element={<MainService />} />
                <Route path='/service' element={<Service />} />
                <Route path='/serviceCategory' element={<ServiceCategory />} />
                <Route path="/uploadImage" element={<UploadImage />} />
                <Route path='/workingDay' element={<WorkingDay />} />
            </Routes>
        </>
    )
}

export default Content